module.exports = __webpack_public_path__ + "img/rail-signal-metal.6f948dc5.png";